import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          setting: {
            header: 'SETTINGS_HEADER',
            save: 'SETTINGS_SAVE_BTN',
            back: 'SETTINGS_BACK_BTN',
          },
        },
      },
    },
  }));
}
